import { render, staticRenderFns } from "./AccessGroupNew.vue?vue&type=template&id=5cc6774a&scoped=true&"
import script from "./AccessGroupNew.vue?vue&type=script&lang=js&"
export * from "./AccessGroupNew.vue?vue&type=script&lang=js&"
import style0 from "./AccessGroupNew.vue?vue&type=style&index=0&id=5cc6774a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc6774a",
  null
  
)

export default component.exports